var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextField',{attrs:{"value":_vm.value,"name":_vm.name,"max":8,"required":_vm.required,"rules":_vm.rules,"noCounter":""},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }